import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 保存工作单
export function saveWorkPool(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/work.saveWorkPool',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取工作单类型列表
export function listWorkType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/workType.listWorkType',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取组织树
export function listOrgTree() {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.listOrgTree',
      method: 'get',
      params: {
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询员工信息
export function queryStaffInfos(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传文件
export function uploadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/upload',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询员工的部门经理（用于自动填充抄送人）
export function getStaffSuperiors(staffIds) {
  return new Promise((resolve, reject) => {
    request({
      url: '/work.getStaffSuperiors',
      method: 'post',
      data: { staffIds }
    }).then(response => {
      // 后端返回格式: "<200 OK,{json数据},{}>"
      let raw = response.data
      if (typeof raw === 'string') {
        // 去掉 "<200 OK," 前缀
        if (raw.startsWith('<200 OK,')) {
          raw = raw.substring(8)
        }
        // 去掉末尾的 ",{}>" 后缀
        if (raw.endsWith(',{}>')) {
          raw = raw.substring(0, raw.length - 4)
        } else if (raw.endsWith('>')) {
          raw = raw.substring(0, raw.length - 1)
        }
      }
      const data = typeof raw === 'string' ? JSON.parse(raw) : raw
      console.log('【API层 v13】返回:', data)
      resolve(data)
    }).catch(error => {
      console.error('【API层 v13】错误:', error)
      reject(error)
    })
  })
}
// 【新增】按部门和小区查询员工（用于小区主管选人）
export function queryStaffInCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/work.queryStaffInCommunity',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 【新增】按部门查询员工（无权限过滤，用于Manager选人）
export function listStaffByOrg(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/work.listStaffByOrg',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
